import { gql } from '@apollo/client'

const LAYER_FIELDS = `
  present
  rate
  allocation
  changedAt
  minimumStay
  closed
`

export const INVENTORY_HEALTH_QUERY = gql`
  query InventoryHealthDiagnostic($input: InventoryHealthFilters!) {
    inventoryHealthDiagnostic(input: $input) {
      totalRows
      differingRows
      overallStatus
      findings {
        code
        severity
        subject
        detail
      }
      credentials {
        providerCode
        providerName
        providerAdapter
        providerURL
        active
        channels {
          channelID
          channelCode
          channelName
          active
          hasPMSCode
          hasPMSPass
          pmsPassLength
          pmsPassPadded
          pmsCodePadded
          sharesPassWith
          sharesCodeWith
        }
      }
      rows {
        date
        roomTypeCode
        roomTypeName
        ratePlanCode
        ratePlanName
        channelID
        channelName
        status
        findingCodes
        pms { ${LAYER_FIELDS} }
        crs { ${LAYER_FIELDS} }
        channel { ${LAYER_FIELDS} }
      }
    }
  }
`
